import { Grid, TextField, Typography } from "@material-ui/core"
import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import { Autocomplete } from "@material-ui/lab"
import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { createNewOTAMessage, fetchUserOTAMessages } from "../../../actions/otaActions"
import { OTA_MESSAGE_TYPES } from "../../../util/constants"
import ResetDeviceOTAMessageSection from "./resetDeviceOTAMessageSection"
import UpdateModelSettingsSection from "./updateModelSettingsSection"
import UpdateSettingsSection from "./updateSettingsSection"

export default function NewOTAMessage(props) {
  const { allDevices, allReleases } = props
  const [messageType, setMessageType] = useState(null)
  const [messageData, setMessageData] = useState(null)
  const [deviceIds, setDeviceIds] = useState([])
  const [validated, setValidated] = useState(false)
  const [errorText, setErrorText] = useState([])
  const [open, setOpen] = useState(false)
  const dispatch = useDispatch()

  const handleSave = async () => {
    setErrorText([])
    if (!deviceIds || deviceIds.length === 0 || !validated || !messageData || !messageType) {
      setErrorText(["Please fill in all required fields."])
      return
    }
    const promises = []
    for (const deviceId of deviceIds) {
      promises.push(createNewOTAMessage(deviceId.id, messageType, messageData))
    }
    const responses = await Promise.all(promises)
    const errors = responses.filter((res) => !res.status)
    setErrorText(
      errors.map(
        (res) =>
          `OTA message failed creation for device: ${res.deviceId}. Either there is an unexpected issue or the message limit for the device has been reached.`,
      ),
    )
    dispatch(fetchUserOTAMessages())
    if (errors.length === 0) {
      setOpen(false)
    }
  }

  const getMessageTypeSection = () => {
    switch (messageType) {
      case OTA_MESSAGE_TYPES.RESET_DEVICE:
        return (
          <ResetDeviceOTAMessageSection
            setMessageData={setMessageData}
            setValidated={setValidated}
          />
        )
      case OTA_MESSAGE_TYPES.UPDATE_MODEL_SETTINGS:
        return (
          <UpdateModelSettingsSection
            setMessageData={setMessageData}
            setValidated={setValidated}
            releaseIds={allReleases.map((release) => release.id.toString())}
          />
        )
      case OTA_MESSAGE_TYPES.UPDATE_SETTINGS:
        return <UpdateSettingsSection setMessageData={setMessageData} setValidated={setValidated} />
    }
  }

  return (
    <>
      <Button
        variant="outlined"
        color="primary"
        onClick={() => {
          setOpen(true)
        }}
      >
        Create new OTA Message
      </Button>
      <Dialog open={open} onClose={() => setOpen(false)}>
        <DialogTitle>Create new OTA Message</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography color="primary">
                Choose device IDs and an OTA message type. Additional options will appear based on
                your selection. Greyed out device IDs lack the required firmware version.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                multiple
                onChange={(_, value) => setDeviceIds(value)}
                value={deviceIds}
                options={allDevices}
                getOptionLabel={(option) => option.id}
                getOptionDisabled={(option) => !option.approved}
                renderInput={(params) => <TextField required {...params} label="Device IDs" />}
              />
            </Grid>
            <Grid item xs={12}>
              <Autocomplete
                onChange={(_, value) => setMessageType(value)}
                value={messageType}
                options={[
                  OTA_MESSAGE_TYPES.RESET_DEVICE,
                  OTA_MESSAGE_TYPES.UPDATE_MODEL_SETTINGS,
                  OTA_MESSAGE_TYPES.UPDATE_SETTINGS,
                ]}
                renderInput={(params) => <TextField required {...params} label="Message Type" />}
              />
            </Grid>
            {getMessageTypeSection()}
          </Grid>
          {errorText?.map((textLine) => {
            return (
              <Typography key={textLine.slice(0, 10)} color="secondary">
                {textLine}
              </Typography>
            )
          })}
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={() => setOpen(false)}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleSave} variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
